import React from 'react';

const OverlappingLines = ({ baseLineLength, dataLineLength, baseLineColor, dataLineColor, x, y }) => {
  // Default values if props are not provided
  const defaultLength = 0;
  const defaultColor = '#000000';

  // SVG dimensions
  const svgWidth = Math.max(baseLineLength || defaultLength, dataLineLength || defaultLength);
  const svgHeight = 4;

  return (
    <svg viewbox="0, 0, {svgWidth}, {svgHeight}" >
      {/* First line */}
      <line
        x1={x || 0}
        y1={y || 0}
        x2={baseLineLength || defaultLength}
        y2={y || 0}
        stroke={baseLineColor || defaultColor}
        strokeWidth="4"
      />
      {/* Second line */}
      <line
        x1={x || 0}
        y1={y || 0}
        x2={dataLineLength || defaultLength}
        y2={y || 0}
        stroke={dataLineColor || defaultColor}
        strokeWidth="4"
      />
    </svg>
  );
};

export default OverlappingLines;